import React, { Component } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { formatUtcAsLocalTime } from "../utils/datetime";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const COLORS = ["#ff0092", "#ffca1b", "#b6ff00", "#228dff", "#ba01ff", "#00d5b0", "#ff7a00"];

/**
 * Fluxo de créditos: uma série por bot com histórico no período.
 *
 * - Sempre recebe a lista completa de apostas (todos os bots).
 * - Clique na legenda: liga/desliga a série e seleciona o bot.
 * - Clique na linha/ponto: seleciona o bot para filtrar logs e apostas.
 * - Valores em reais inteiros (sem centavos).
 */
class CrashDashboard extends Component {
  labelFor = (bet, index, bets) => {
    const hour = formatUtcAsLocalTime(bet.created_at) || "";
    if (index === 0) return hour;

    const previous = formatUtcAsLocalTime(bets[index - 1].created_at) || "";
    return previous.substring(0, 2) === hour.substring(0, 2) ? " " : hour;
  };

  creditOf = (bet) => Math.round(Number(bet && bet.credit) || 0);

  buildChartData = (bets) => {
    const labels = [];
    const series = new Map();
    const selectedId =
      this.props.selectedUserId != null ? Number(this.props.selectedUserId) : null;

    bets.forEach((bet, index) => {
      if (!bet.user_id) return;

      labels.push(this.labelFor(bet, index, bets));

      if (!series.has(bet.user_id)) {
        const color = COLORS[series.size % COLORS.length];
        const isSelected = selectedId != null && Number(bet.user_id) === selectedId;
        series.set(bet.user_id, {
          userId: Number(bet.user_id),
          label: (bet.user && bet.user.name) || `Bot #${bet.user_id}`,
          data: new Array(labels.length - 1).fill(null),
          borderColor: isSelected ? color : `${color}99`,
          backgroundColor: isSelected ? color : `${color}99`,
          borderWidth: isSelected ? 3 : 2,
          pointRadius: isSelected ? 3 : 2,
        });
      }

      series.forEach((dataset, userId) => {
        const last = dataset.data.length ? dataset.data[dataset.data.length - 1] : null;
        dataset.data.push(userId === bet.user_id ? this.creditOf(bet) : last);
      });
    });

    return { labels, datasets: Array.from(series.values()) };
  };

  handleChartClick = (evt, elements, chart) => {
    if (!elements || !elements.length || !this.props.onSelectBot || !chart) return;
    const ds = chart.data.datasets[elements[0].datasetIndex];
    if (ds && ds.userId != null) {
      this.props.onSelectBot(ds.userId);
    }
  };

  /**
   * Legenda: toggle de visibilidade (padrão Chart.js) + seleciona o bot
   * para logs/apostas/prompts da aba.
   */
  handleLegendClick = (evt, item, legend) => {
    const chart = legend.chart;
    const index = item.datasetIndex;

    if (chart.isDatasetVisible(index)) {
      chart.hide(index);
      item.hidden = true;
    } else {
      chart.show(index);
      item.hidden = false;
    }

    const ds = chart.data.datasets[index];
    if (ds && ds.userId != null && this.props.onSelectBot) {
      this.props.onSelectBot(ds.userId);
    }
  };

  render() {
    const bets = [...(this.props.bets || [])].reverse();
    const data = this.buildChartData(bets);
    const botCount = data.datasets.length;

    return (
      <div style={{ marginBottom: 16 }}>
        <Line
          options={{
            responsive: true,
            spanGaps: true,
            onClick: this.handleChartClick,
            plugins: {
              legend: {
                position: "top",
                onClick: this.handleLegendClick,
                labels: {
                  usePointStyle: true,
                  generateLabels: (chart) => {
                    const defaultGen = ChartJS.defaults.plugins.legend.labels.generateLabels;
                    const base = defaultGen(chart);
                    const selectedId =
                      this.props.selectedUserId != null
                        ? Number(this.props.selectedUserId)
                        : null;
                    return base.map((item) => {
                      const ds = chart.data.datasets[item.datasetIndex];
                      const isSelected =
                        selectedId != null && ds && Number(ds.userId) === selectedId;
                      return {
                        ...item,
                        text: isSelected ? `${item.text} ●` : item.text,
                      };
                    });
                  },
                },
              },
              title: {
                display: true,
                text:
                  botCount > 0
                    ? `FLUXO DE CRÉDITOS — últimas 24h (${botCount} bot${botCount === 1 ? "" : "s"})`
                    : "FLUXO DE CRÉDITOS — últimas 24h",
              },
              tooltip: {
                callbacks: {
                  label: (ctx) => {
                    const value = ctx.parsed && ctx.parsed.y;
                    if (value == null || Number.isNaN(value)) return ctx.dataset.label;
                    return `${ctx.dataset.label}: R$ ${Math.round(value)}`;
                  },
                },
              },
            },
            scales: {
              y: {
                ticks: {
                  callback: (value) => Math.round(Number(value)),
                  precision: 0,
                },
              },
            },
          }}
          data={data}
        />
        <p style={{ color: "#757575", fontSize: 12, marginTop: 4, marginBottom: 0 }}>
          Legenda: clique para mostrar/ocultar a série e selecionar o bot. Clique na linha
          também seleciona. O bot selecionado filtra logs, apostas e prompts abaixo.
        </p>
      </div>
    );
  }
}

export default CrashDashboard;
